import { http } from 'vue'
import _ from 'lodash'
let r1 = false
let resource = 'brands'
export default {
  loadShoppingBrands (context, params = {}) {
    let subcategoryId = (params.subcategoryId) ? '&subcategory_id=' + params.subcategoryId : ''
    let productId = (params.productId) ? '&product_id=' + params.productId : ''
    let skuId = (params.skuId) ? '&sku_id=' + params.skuId : ''
    let filters = params.filters ? '&filters=' + _.join(params.filters, '_') : ''
    let brandId = (params.brandId) ? '&brand_id=' + params.brandId : ''
    let cityId = (params.cityId) ? '&city_id=' + params.cityId : ''
    return http.get('shopping/' + resource + '?category_id=1' + subcategoryId + productId + cityId + brandId + skuId + filters, {
      before (request) {
        if (r1) r1.abort()
        r1 = request
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/brands/actions.js